import React, { useContext } from "react";

import { Button, Grid, IconButton, CircularProgress } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import InfoIcon from "@material-ui/icons/Info";
import styled, { css } from "styled-components";
import { observer } from "mobx-react";
import { TextField } from "@material-ui/core";

import CheckIcon from "@material-ui/icons/Check";
import { ContainerStoreContext } from "./ContainerStore";

function SaveResetButtons({ open, type = "snackbar", iconHidden = false }) {
  const store = useContext(ContainerStoreContext);
  const [isNewView, setIsNewView] = React.useState(false);
  React.useEffect(() => setIsNewView(false), [open]);

  if (!open) {
    return null;
  }

  return (
    <Grid container fullWidth item xs alignItems="center" direction="row">
      {!iconHidden && (
        <Grid item>
          <InfoIcon />
        </Grid>
      )}
      {!isNewView ? (
        <ButtonsGroup
          store={store}
          // variant={type === "snackbar" ? "text" : "text"}
          dark={type === "snackbar"}
          onSaveAsNewViewClick={() => setIsNewView(true)}
        />
      ) : (
        <NewViewNameInput
          store={store}
          type={type}
          dark={type === "snackbar"}
          onCancel={() => setIsNewView(false)}
        />
      )}
    </Grid>
  );
}

function ButtonsGroup({ store, onSaveAsNewViewClick, variant, dark = false }) {
  const [isSaving, setSaving] = React.useState(false);
  let isSubsheetView =
    store.view?.type == "table" &&
    store.view?.list_id &&
    store.view?.options?.main_list_id &&
    store.view?.list_id != store.view?.options?.main_list_id &&
    !store.unSavedViewOfEditReport

  return (
    <>
      <Grid item>
        {((store.permissions.isAdmin() ||
          store.view.created_by == LOGGED_IN_USER.user_id) && !store.unSavedViewOfEditReport && !isSubsheetView) && (
          <StyledButtton
            key="undo"
            color="primary"
            size="small"
            variant={variant}
            dark={dark}
            onClick={async () => {
              setSaving(true);
              const viewForSave = store.getCurrentViewStore().viewForSave;
              const view = await store.saveView(viewForSave);
              setSaving(false);
              if (!view) {
                return;
              }
              store.resetRunningReportData(false);
              store.handleViewChange(view.id, true, view);
            }}
          >
            SAVE VIEW
            {isSaving && <CircularProgress size={18} color="inherit" />}
          </StyledButtton>
        )}
      </Grid>
      <Grid item>
        {!isSubsheetView && (
          <StyledButtton
            key="undo"
            color="primary"
            size="small"
            variant={variant}
            dark={dark}
            disabled = {store.listConfig?.list?.is_log_sheet == 1 ? true : false }
            onClick={onSaveAsNewViewClick}
          >
            SAVE AS NEW VIEW
         </StyledButtton>
        )}
      </Grid>
      <Grid item>
        {(store.unSavedViewOfEditReport && store.unSavedViewOfEditReport?.is_main_view != "1" && (store.view.created_by == window.LOGGED_IN_USER.user_id || store.permissions?.canChangeSettings())) && (
          <StyledButtton
            key="undo"
            color="primary"
            size="small"
            variant={variant}
            dark={dark}
            onClick={() => {store.handleEditReport(store.unSavedViewOfEditReport.id, true, store.unSavedViewOfEditReport)}}
          >
            EDIT
          </StyledButtton>
        )}
      </Grid>
      <Grid item>
        <StyledButtton
          key="undo"
          color="primary"
          size="small"
          variant={variant}
          dark={dark}
          onClick={async () => {
            await store.getCurrentViewStore().resetView?.();
            await store.resetSaveResetButtonsPostion();
            store.resetRunningReportData(true);
          }}
        >
          RESET
        </StyledButtton>
      </Grid>
      <Grid item>
        <StyledIconButton
          key="close"
          aria-label="close"
          color="inherit"
          size="small"
          dark={dark}
          onClick={() => {
            store.toggleSaveResetButtonsPostion();
          }}
        >
          <CloseIcon />
        </StyledIconButton>
      </Grid>
    </>
  );
}

function NewViewNameInput({ onCancel, onSave, store, dark }) {
  const [isNewViewSaving, setNewViewSaving] = React.useState(false);
  const [viewName, setViewName] = React.useState("");

  const handleClick = async () => {
    setNewViewSaving(true);
    let newView = store.getCurrentViewStore().viewForSave;
    newView.name = viewName;
    newView.id = -1;
    newView.is_main_dashboard_view = 0;
    newView.is_default = 0;
    newView.is_main_view = 0;

    const view = await store.saveView(newView);
    setNewViewSaving(false);
    if (!view) {
      return;
    }
    store.getCurrentViewStore().resetView?.();
    store.resetRunningReportData(false);
    store.handleViewChange(view.id, false, view);
  };

  return (
    <>
      <TextFieldGrid item xs>
        <StyledTextField
          autoFocus
          fullWidth
          color="white"
          placeholder="View Name"
          dark={dark}
          disabled={isNewViewSaving}
          onChange={(e) => setViewName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleClick();
            }
          }}
        />
      </TextFieldGrid>
      <Grid item>
        <StyledIconButton
          dark={dark}
          disabled={isNewViewSaving}
          onClick={handleClick}
          size="small"
        >
          {!isNewViewSaving ? (
            <CheckIcon />
          ) : (
            <CircularProgress size={18} color="inherit" />
          )}
        </StyledIconButton>
      </Grid>
      <Grid item>
        <StyledIconButton
          key="close"
          aria-label="close"
          color="inherit"
          onClick={onCancel}
          dark={dark}
          size="small"
        >
          <CloseIcon />
        </StyledIconButton>
      </Grid>
    </>
  );
}

const TextFieldGrid = styled(Grid)`
  max-width: 200px;
  min-width: 180px;
`;

const StyledTextField = styled(TextField)`
  ${(props) =>
    props.dark &&
    css`
      input {
        color: white;
      }
    `}
`;

const StyledButtton = styled(Button)`

  ${(props) =>
    props.dark &&
    css`
      color: ${props.disabled ? "grey" : "#fff" } !important;
      &:hover {
        background-color: rgb(255 255 255 / 32%);
      }
    `}
`;

const StyledIconButton = styled(IconButton)`
  ${(props) =>
    props.dark &&
    css`
      color: #fff !important;
      &:hover {
        background-color: rgb(255 255 255 / 32%);
      }
    `}
`;

export default observer(SaveResetButtons);
